import { render, staticRenderFns } from "./CustomersTypes.vue?vue&type=template&id=c0158536"
import script from "./CustomersTypes.vue?vue&type=script&lang=js"
export * from "./CustomersTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports